/* Start Section r_co_marquee_NaYB3J */
document.addEventListener("DOMContentLoaded",()=>{const ele=document.querySelector('.section-template--r_co_marquee_NaYB3J #marquee');const subject=ele.innerHTML;for(var i=0;i<=4;i++){ele.insertAdjacentHTML('beforeend',subject);}
const perentEle=document.querySelector('.section-template--r_co_marquee_NaYB3J .marquee-container');const perentSubject=perentEle.innerHTML;perentEle.insertAdjacentHTML('beforeend',perentSubject);});
/* End Section r_co_marquee_NaYB3J */
/* Start Section lwp_link_grid_NfN6Mj */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.nwkw_bfcm_link_grid-template--lwp_link_grid_NfN6Mj.swiper',{loop:false,slidesPerView:3,spaceBetween:15,roundLengths:true,speed:1500,breakpoints:{768:{slidesPerView:5,spaceBetween:15,loop:false,},},on:{click:function(swiper,event){swiper.slides.forEach(function(slide){slide.classList.remove('active-slide');});const clickedSlide=swiper.clickedSlide;if(clickedSlide){clickedSlide.classList.add('active-slide');}}}});});
/* End Section lwp_link_grid_NfN6Mj */
/* Start Section r_co_product_list_dBryMd */
document.addEventListener('DOMContentLoaded',function(){const toggleVarBtn=document.querySelectorAll('.section-template--r_co_product_list_dBryMd .variant_toggle-wrap');const pageRedirect=(id)=>{window.location.href=`${window.location.origin}?variant=${id}`};toggleVarBtn.forEach(div=>{const button=div.querySelector('.variant_toggle-btn');const closebutton=div.querySelector('.subscription_close');const addToBagbutton=div.querySelector('.button_add_to_bag');const atcForm=div.closest('.product_container-class').querySelector('.shopify-product-form');const optionForm=div.querySelector('.main_pdp_subscription');button.addEventListener('click',e=>{console.log(atcForm.dataset.custom);if(optionForm){div.classList.add('active');}else if(atcForm.dataset.custom=='true'){pageRedirect(atcForm.querySelector('input[name="id"]').value);}else{atcForm.dispatchEvent(new Event('submit'));}});closebutton.addEventListener('click',e=>{if(optionForm){div.classList.remove('active');}});});});function updateGridRows(){const allGridDiv=document.querySelectorAll('.section-template--r_co_product_list_dBryMd .product_container-detials');let maxChildren=0;const allHeight=[];allGridDiv.forEach((div)=>{const childCount=div.children.length;if(childCount>maxChildren){maxChildren=childCount;}});for(let i=0;i<maxChildren;i++){allHeight.push({index:i,height:0});}
allGridDiv.forEach((div)=>{div.style.gridTemplateRows='none';allHeight.forEach((ele,i)=>{if(div.children[i]){const childHeight=div.children[i].offsetHeight;if(childHeight>ele.height){ele.height=childHeight;}}});div.style.gridTemplateRows=null;});allGridDiv.forEach((div)=>{const rowHeights=allHeight.map((ele)=>`${ele.height}px`).join(' ');div.style.gridTemplateRows=rowHeights;});}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows);window.addEventListener('resize',debounce(updateGridRows,100));
/* End Section r_co_product_list_dBryMd */
/* Start Section lwp_video_carousel_AYdx3G */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.section-template--lwp_video_carousel_AYdx3G .swiper',{loop:false,slidesPerView:1.8,spaceBetween:12,speed:1500,navigation:{nextEl:'.section-template--lwp_video_carousel_AYdx3G .next',prevEl:'.section-template--lwp_video_carousel_AYdx3G .prev',clickable:true,},pagination:{el:".dots",clickable:true},breakpoints:{768:{slidesPerView:4.2,loop:false,spaceBetween:24}}});Swipes.on('slideChange',function(){document.querySelectorAll('.section-template--lwp_video_carousel_AYdx3G video-player').forEach(video=>{video.pauseAllVideo();});});});document.querySelectorAll('.section-template--lwp_video_carousel_AYdx3G video-player').forEach(video=>{video.addEventListener('click',function(){document.querySelectorAll('.section-template--lwp_video_carousel_AYdx3G video-player').forEach(ele=>{if(video!=ele){ele.pauseAllVideo();}});});});
/* End Section lwp_video_carousel_AYdx3G */
/* Start Section r_co_product_list_KzedgC */
document.addEventListener('DOMContentLoaded',function(){const toggleVarBtn=document.querySelectorAll('.section-template--r_co_product_list_KzedgC .variant_toggle-wrap');const pageRedirect=(id)=>{window.location.href=`${window.location.origin}?variant=${id}`};toggleVarBtn.forEach(div=>{const button=div.querySelector('.variant_toggle-btn');const closebutton=div.querySelector('.subscription_close');const addToBagbutton=div.querySelector('.button_add_to_bag');const atcForm=div.closest('.product_container-class').querySelector('.shopify-product-form');const optionForm=div.querySelector('.main_pdp_subscription');button.addEventListener('click',e=>{console.log(atcForm.dataset.custom);if(optionForm){div.classList.add('active');}else if(atcForm.dataset.custom=='true'){pageRedirect(atcForm.querySelector('input[name="id"]').value);}else{atcForm.dispatchEvent(new Event('submit'));}});closebutton.addEventListener('click',e=>{if(optionForm){div.classList.remove('active');}});});});function updateGridRows(){const allGridDiv=document.querySelectorAll('.section-template--r_co_product_list_KzedgC .product_container-detials');let maxChildren=0;const allHeight=[];allGridDiv.forEach((div)=>{const childCount=div.children.length;if(childCount>maxChildren){maxChildren=childCount;}});for(let i=0;i<maxChildren;i++){allHeight.push({index:i,height:0});}
allGridDiv.forEach((div)=>{div.style.gridTemplateRows='none';allHeight.forEach((ele,i)=>{if(div.children[i]){const childHeight=div.children[i].offsetHeight;if(childHeight>ele.height){ele.height=childHeight;}}});div.style.gridTemplateRows=null;});allGridDiv.forEach((div)=>{const rowHeights=allHeight.map((ele)=>`${ele.height}px`).join(' ');div.style.gridTemplateRows=rowHeights;});}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows);window.addEventListener('resize',debounce(updateGridRows,100));
/* End Section r_co_product_list_KzedgC */
/* Start Section r_co_product_list_M7EHAw */
document.addEventListener('DOMContentLoaded',function(){const toggleVarBtn=document.querySelectorAll('.section-template--r_co_product_list_M7EHAw .variant_toggle-wrap');const pageRedirect=(id)=>{window.location.href=`${window.location.origin}?variant=${id}`};toggleVarBtn.forEach(div=>{const button=div.querySelector('.variant_toggle-btn');const closebutton=div.querySelector('.subscription_close');const addToBagbutton=div.querySelector('.button_add_to_bag');const atcForm=div.closest('.product_container-class').querySelector('.shopify-product-form');const optionForm=div.querySelector('.main_pdp_subscription');button.addEventListener('click',e=>{console.log(atcForm.dataset.custom);if(optionForm){div.classList.add('active');}else if(atcForm.dataset.custom=='true'){pageRedirect(atcForm.querySelector('input[name="id"]').value);}else{atcForm.dispatchEvent(new Event('submit'));}});closebutton.addEventListener('click',e=>{if(optionForm){div.classList.remove('active');}});});});function updateGridRows(){const allGridDiv=document.querySelectorAll('.section-template--r_co_product_list_M7EHAw .product_container-detials');let maxChildren=0;const allHeight=[];allGridDiv.forEach((div)=>{const childCount=div.children.length;if(childCount>maxChildren){maxChildren=childCount;}});for(let i=0;i<maxChildren;i++){allHeight.push({index:i,height:0});}
allGridDiv.forEach((div)=>{div.style.gridTemplateRows='none';allHeight.forEach((ele,i)=>{if(div.children[i]){const childHeight=div.children[i].offsetHeight;if(childHeight>ele.height){ele.height=childHeight;}}});div.style.gridTemplateRows=null;});allGridDiv.forEach((div)=>{const rowHeights=allHeight.map((ele)=>`${ele.height}px`).join(' ');div.style.gridTemplateRows=rowHeights;});}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows);window.addEventListener('resize',debounce(updateGridRows,100));
/* End Section r_co_product_list_M7EHAw */
/* Start Section r_co_product_list_g9MzaJ */
document.addEventListener('DOMContentLoaded',function(){const toggleVarBtn=document.querySelectorAll('.section-template--r_co_product_list_g9MzaJ .variant_toggle-wrap');const pageRedirect=(id)=>{window.location.href=`${window.location.origin}?variant=${id}`};toggleVarBtn.forEach(div=>{const button=div.querySelector('.variant_toggle-btn');const closebutton=div.querySelector('.subscription_close');const addToBagbutton=div.querySelector('.button_add_to_bag');const atcForm=div.closest('.product_container-class').querySelector('.shopify-product-form');const optionForm=div.querySelector('.main_pdp_subscription');button.addEventListener('click',e=>{console.log(atcForm.dataset.custom);if(optionForm){div.classList.add('active');}else if(atcForm.dataset.custom=='true'){pageRedirect(atcForm.querySelector('input[name="id"]').value);}else{atcForm.dispatchEvent(new Event('submit'));}});closebutton.addEventListener('click',e=>{if(optionForm){div.classList.remove('active');}});});});function updateGridRows(){const allGridDiv=document.querySelectorAll('.section-template--r_co_product_list_g9MzaJ .product_container-detials');let maxChildren=0;const allHeight=[];allGridDiv.forEach((div)=>{const childCount=div.children.length;if(childCount>maxChildren){maxChildren=childCount;}});for(let i=0;i<maxChildren;i++){allHeight.push({index:i,height:0});}
allGridDiv.forEach((div)=>{div.style.gridTemplateRows='none';allHeight.forEach((ele,i)=>{if(div.children[i]){const childHeight=div.children[i].offsetHeight;if(childHeight>ele.height){ele.height=childHeight;}}});div.style.gridTemplateRows=null;});allGridDiv.forEach((div)=>{const rowHeights=allHeight.map((ele)=>`${ele.height}px`).join(' ');div.style.gridTemplateRows=rowHeights;});}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows);window.addEventListener('resize',debounce(updateGridRows,100));
/* End Section r_co_product_list_g9MzaJ */
/* Start Section r_co_review_gN8Da8 */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.section-template--r_co_review_gN8Da8 .swiper',{loop:true,slidesPerView:1,spaceBetween:24,grabCursor:false,roundLengths:true,pagination:{el:".dots",clickable:true}});});
/* End Section r_co_review_gN8Da8 */
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
/*
class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.videoWeb = this.videos[0];
    this.videoMob = this.videos[1];
    this.playBtn = this.querySelector('.play-btn');
    this.soundBtn = this.querySelector('.mute-btn');
    this.disableClick = this.dataset.click;
    if (this.disableClick) {
      this.initEventListeners();
    }
  }

  initEventListeners() {
    this.videos.forEach(video => {
      video.addEventListener('click', () => this.togglePlay(video));
      video.addEventListener('ended', () => this.handleVideoEnded(video)); // Listen for the `ended` event
    });

    if (this.playBtn) {
      this.playBtn.addEventListener('click', () => this.handlePlayButton());
    }

    if (this.soundBtn) {
      this.soundBtn.addEventListener('click', () => this.toggleMute());
    }

    window.addEventListener('resize', () => this.handleResize());
  }

  togglePlay(video) {
    if (video.paused) {
      this.playVideo(video);
    } else {
      this.pauseVideo(video);
    }
  }

  playVideo(video) {
    this.videos.forEach(otherVideo => {
      if (otherVideo !== video) otherVideo.pause();
    });
    video.play();
    this.classList.add('played');
  }

  pauseVideo(video) {
    video.pause();
    this.classList.remove('played');
  }

  handlePlayButton() {
    const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
    if (targetVideo) this.togglePlay(targetVideo);
  }

  toggleMute() {
    const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
    if (targetVideo) {
      targetVideo.muted = !targetVideo.muted;
      this.soundBtn.classList.toggle('active', targetVideo.muted);
    }
  }

  handleResize() {
    if (!this.videoMob) return;

    const isMobile = window.innerWidth < 749;
    const targetVideo = isMobile ? this.videoMob : this.videoWeb;

    this.videos.forEach(video => video.pause());
    targetVideo.play();
    targetVideo.pause(); // Ensure the video is ready for user interaction
  }

  handleVideoEnded(video) {
    // Check if the video is not set to loop
    if (!video.loop) {
      this.classList.remove('played');
    }
  }
}

customElements.define('video-player', VideoPlayer);
*/
(function () {
  // Check if the custom element is already defined
  if (!customElements.get('video-player')) {
    class VideoPlayer extends HTMLElement {
      constructor() {
        super();
        this.videos = this.querySelectorAll('video');
        this.videoWeb = this.videos[0];
        this.videoMob = this.videos[1];
        this.playBtn = this.querySelector('.play-btn');
        this.soundBtn = this.querySelector('.mute-btn');
        this.disableClick = this.dataset.click;

        if (this.disableClick) {
          this.initEventListeners();
        }
      }

      initEventListeners() {
        this.videos.forEach(video => {
          video.addEventListener('click', () => this.togglePlay(video));
          video.addEventListener('ended', () => this.handleVideoEnded(video));
        });

        if (this.playBtn) {
          this.playBtn.addEventListener('click', () => this.handlePlayButton());
        }

        if (this.soundBtn) {
          this.soundBtn.addEventListener('click', () => this.toggleMute());
        }

        window.addEventListener('resize', () => this.handleResize());
      }

      togglePlay(video) {
        if (video.paused) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      }

      playVideo(video) {
        this.videos.forEach(otherVideo => {
          if (otherVideo !== video) {
            otherVideo.pause();
            otherVideo.muted = true;
          }
        });

        video.muted = false;
        video.play();
        this.classList.add('played');

        // ✅ Hide the Play button
        if (this.playBtn) {
          this.playBtn.style.opacity = '0';
          this.playBtn.style.pointerEvents = 'none'; // Prevent clicking while hidden
        }

        if (this.soundBtn) {
          this.soundBtn.classList.remove('active');
        }
      }

      pauseVideo(video) {
        video.pause();
        video.muted = true;
        this.classList.remove('played');

        // ✅ Show the Play button again
        if (this.playBtn) {
          this.playBtn.style.opacity = '1';
          this.playBtn.style.pointerEvents = 'auto';
        }

        if (this.soundBtn) {
          this.soundBtn.classList.add('active');
        }
      }
      pauseAllVideo() {
        this.videos.forEach(video => {
          this.pauseVideo(video)
        });
      }

      handlePlayButton() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) this.togglePlay(targetVideo);
      }

      toggleMute() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) {
          targetVideo.muted = !targetVideo.muted;
          this.soundBtn.classList.toggle('active', targetVideo.muted);
        }
      }

      handleResize() {
        if (!this.videoMob) return;

        const isMobile = window.innerWidth < 749;
        const targetVideo = isMobile ? this.videoMob : this.videoWeb;

        this.videos.forEach(video => {
          video.pause();
          video.muted = true;
        });

        targetVideo.play();
        targetVideo.muted = false;
        targetVideo.pause();
      }

      handleVideoEnded(video) {
        if (!video.loop) {
          this.classList.remove('played');
          video.muted = true;

          // ✅ Show the Play button again
          if (this.playBtn) {
            this.playBtn.style.opacity = '1';
            this.playBtn.style.pointerEvents = 'auto';
          }
        }
      }
    }

    // Define the custom element
    customElements.define('video-player', VideoPlayer);
  }
})();